/**
=========================================================
* Iris Design Limited  Fulfilment POD - v2.2.0
=========================================================

* Product Page: https://www.irisdesignlimited.com/product/material-dashboard-react
* Copyright 2023 Dev Iris Design Limited Company (https://www.irisdesignlimited.com)

Coded by www.irisdesignlimited.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/**
 * The base border styles for the Iris Design Limited  Fulfilment POD.
 * You can add new border width, border color or border radius using this file.
 * You can customized the borders value for the entire Iris Design Limited  Fulfilment POD using thie file.
 */

// Iris Design Limited  Fulfilment POD Base Styles
import colors from "assets/theme/base/colors";

// Iris Design Limited  Fulfilment POD Helper Functions
import pxToRem from "assets/theme/functions/pxToRem";

const { grey } = colors;

const borders = {
  borderColor: grey[300],

  borderWidth: {
    0: 0,
    1: pxToRem(1),
    2: pxToRem(2),
    3: pxToRem(3),
    4: pxToRem(4),
    5: pxToRem(5),
  },

  borderRadius: {
    xs: pxToRem(4),
    sm: pxToRem(6),
    md: pxToRem(8),
    lg: pxToRem(10),
    xl: pxToRem(12),
    xxl: pxToRem(16),
    section: pxToRem(160),
  },
};

export default borders;
